// extracted by mini-css-extract-plugin
export var hero = "hero-module--hero--6D8n+";
export var heroBadge = "hero-module--hero-badge--BI3Kz";
export var heroImg = "hero-module--hero-img--HUy44";
export var heroInfo = "hero-module--hero-info--o7e6R";
export var heroName = "hero-module--hero-name--fxq0d";
export var heroPosition = "hero-module--hero-position--aw-az";